var ePath =localStorage.getItem('excelpath')
let excelPath={
    state:{
        excelPath:ePath,
    },
    getters: {},
    mutations: {
        setExcelPath(state,res){
            state.excelPath = res
            localStorage.getItem('excelpath',JSON.stringify(state.excelPath))  
        }
    },
    actions: {}
};

export default excelPath;